export const RAIN_KEY = "__rain__form__"

export const rain_api = (step: string, data: unknown) => {
  return new Promise((resolve) => {
    setTimeout(
      () => {
        const obj = JSON.parse(localStorage.getItem(RAIN_KEY) || "{}")
        console.log(step, obj)
        Object.assign(obj, { [step]: data })
        localStorage.setItem(RAIN_KEY, JSON.stringify(obj))
        resolve({
          step,
          data,
        })
      },
      1000 + (Math.round(Math.random() * 5) + 1) * 100,
    )
  })
}

export const validate_rain = (step: string | string[]) => {
  const obj = JSON.parse(localStorage.getItem(RAIN_KEY) || "{}")
  if (step === "") return "company-info" in obj
  if (typeof step === "object") return step.some((key) => key in obj)
  return step in obj
}

export const get_rain_form_data = (step: string) => {
  return JSON.parse(localStorage.getItem(RAIN_KEY) || "{}")[step]
}
